import { DefaultSections, startPresentation } from "@presentation/Types";

import Introduction from "./Slides/IntroAndOutro/Introduction.vue";
import ThankYou from "./Slides/IntroAndOutro/ThankYou.vue";
import OpportunityCalculator from "./Slides/ResellerProposition/OpportunityCalculator.vue";
import Page1 from "./Slides/Pages/Page-1.vue";
import Page2 from "./Slides/Pages/Page-2.vue";
import Page3 from "./Slides/Pages/Page-3.vue";
import Page4 from "./Slides/Pages/Page-4.vue";
import Page5 from "./Slides/Pages/Page-5.vue";
import Page6 from "./Slides/Pages/Page-6.vue";
import Page6b from "./Slides/Pages/Page-6b.vue";
import Page7 from "./Slides/Pages/Page-7.vue";
import Page8 from "./Slides/Pages/Page-8.vue";
import Page9 from "./Slides/Pages/Page-9.vue";

export const useGlobalResellerPresentation = () => startPresentation(
{

    key: 'global',
    title: 'Global Reseller Presentation',
    password: 'domination', 
    enableNextSlideIndicator: true,

    theme: {
        logo: '/cv-logo.png',
        logoClass: '!h-14 -mt-2 2xl:!h-20 2xl:mt-0',
        textColor: '#262626',
        headerColor: '#2b85be',
        bgColorFrom: '#ffffff',
        bgColorTo: '#ffffff',
        navColorFrom: '#eeeeee',
        navColorTo: '#dddddd',
        navBorderColor: '#26262677',
        nextButtonBackground: '#2b85be',
        nextButtonText: '#ffffff',
        triggerButtonBackground: '#10b981',
        triggerButtonText: '#ffffff',
        showImageOnTitlePages: false,
        showHorizonLine: false,
        keyMessageColor: '#2b85be',
        bgColorPassword: '#dddddd'
    },

    sections: [

        // Introduction
        { 
            name: DefaultSections.Start, 
            title: 'Introduction',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Introduction }
            ],
            images: [
            ]
        },

        { 
            name: 'page-1', 
            title: 'Executive Summary',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Page1 }
            ],
            images: [
            ]
        },
        
        { 
            name: 'page-2', 
            title: 'Market Gap',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Page2 }
            ],
            images: [
            ]
        },

        { 
            name: 'page-3', 
            title: 'The Product',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Page3 }
            ],
            images: [
            ]
        },

        { 
            name: 'page-4', 
            title: 'Why Dealers Love It',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Page4 }
            ],
            images: [
            ]
        },

        { 
            name: 'page-5', 
            title: 'Why Consumers Buy It',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Page5 }
            ],
            images: [
            ]
        },

        { 
            name: 'page-6', 
            title: 'Reseller Opportunity',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Page6 },
                { title: '', component: Page6b }
            ],
            images: [
            ]
        },

        { 
            name: 'page-7', 
            title: 'Support Provided',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Page7 }
            ],
            images: [
            ]
        },

        { 
            name: 'page-8', 
            title: 'Ideal Reseller',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Page8 }
            ],
            images: [
            ]
        },

        { 
            name: 'page-9', 
            title: 'Next Steps',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Page9 }
            ],
            images: [
            ]
        },

        // Calculator
        { 
            name: 'calculator', 
            title: 'Calculator',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { component: OpportunityCalculator },
            ],
            images: [ 
           ]   
        },

        // Thank You
        { 
            name: DefaultSections.End, 
            title: 'Questions',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { component: ThankYou }
            ],
            images: [ 
            ]   
        },
        
    ]

})
